import {
	btn,
	ContainerFieldValue,
	fieldset,
	Form,
	form,
	tbar,
	textarea,
	textfield,
	Window,
	hiddenfield,
	EntityID, Format, arrayfield, containerfield, displayfield, ContainerField, comp, ArrayField, BrowserStore, browser
} from "@intermesh/goui";
import {client, modules, UploadResponse} from "@intermesh/groupoffice-core";


import {t} from "./Translate";

export class SendWindow extends Window {
	private form: Form<ContainerFieldValue>;
	private attachments: ArrayField<UploadResponse>;

	constructor(public readonly formId:EntityID) {
		super();

		this.title = t("Send");

		this.width = 800;
		this.height = 600

		const mod = modules.get("business", "forms")!;

		this.items.add(
			this.form = form({
					flex: 1,
					cls: "vbox",
					handler: () => {
							void this.submit();
					}
				},
				fieldset({flex: 1, cls: "vbox gap"},

					hiddenfield({
						name: "id",
						value: this.formId
					}),
					textfield({
						name: "subject",
						label: t("Subject"),
						required: true,
						value: mod.settings!.templateSubject
					}),

					textarea({
						flex: 1,
						name: "body",
						label: t("Body"),
						value: mod.settings!.templateBody
					}),

					comp({cls: "hbox"},

						this.attachments = arrayfield<UploadResponse>({
							flex: 1,
							name: "attachments",
							buildField: (v) => {
								return containerfield({
										cls: "hbox",
										style: {width: "auto"}
									},
									displayfield({
										escapeValue: false,
										flex: 1,
										value: `<i class="icon">description</i> ${Format.escapeHTML(v!.name)}`,
									}),
									btn({
										icon: "delete",
										handler: (button, ev) => {
											button.findAncestorByType(ContainerField)!.remove()
										}
									})
								)
							}
						}),

						btn({
							icon: "attach_file_add",
							handler: async () => {
								const files = await browser.pickLocalFiles(true, false);
								this.mask();
								const blobs = await client.uploadMultiple(files);
								this.unmask();
								this.attachments.value = this.attachments.value.concat(blobs);

							}
						})
					)
				),

				tbar({},
					"->",

					btn({
						type: "submit",
						text: t("Send"),
						icon: "send"
					})
				)
			)
		)
	}

	private async submit() {
		try {
			this.mask();

			const response = await client.jmap("Form/send", this.form.value);

			let msg = t("Sent {count} messages.").replace("{count}", response.sent);

			const errorCount = response.errors.length;

			if(errorCount) {
				msg += "<br><hr><br>" + t("There were {errorCount} errors").replace("{errorCount}", errorCount)
				 + response.errors.map((e:string) => Format.escapeHTML(e)).join("<br>");
			}

			await Window.alert(msg);
			this.close();
		} catch (e) {
			this.unmask();
			void Window.error(e);
		}
	}
}